import { render } from "./ResidentPassEdit.vue?vue&type=template&id=91c20538&scoped=true"
import script from "./ResidentPassEdit.vue?vue&type=script&lang=js"
export * from "./ResidentPassEdit.vue?vue&type=script&lang=js"

import "./ResidentPassEdit.vue?vue&type=style&index=0&id=91c20538&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c20538"],['__file',"src/assets/js/pages/Address/ResidentPassEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91c20538"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91c20538', __exports__)) {
    api.reload('91c20538', __exports__)
  }
  
  module.hot.accept("./ResidentPassEdit.vue?vue&type=template&id=91c20538&scoped=true", () => {
    api.rerender('91c20538', render)
  })

}


export default __exports__